import {Identity} from 'rlink-utils/functional';
import {makeTagString} from 'rlink-utils/string';

let markerPattern = /<(.+?)>/g;
let namedMarkerPattern = '<MARKER:(.+?):MARKER>';
let stringReplacePattern = '%MARKER(.+?)%';

export class Locale {
  constructor (name) {
    this.name = name;
  }

  links (key, linkValues, attrs) {
    let text = this[key];

    for (let marker in linkValues) {
      let pattern = new RegExp(namedMarkerPattern.replace(/MARKER/g, marker));
      text = text.replace(pattern, (_, match) => {
        attrs.href = linkValues[marker];
        return makeTagString('a', attrs, match);
      });
    }

    return {__html: text};
  }

  markerWrap (key, wrap, attrs, transform) {
    if (!attrs) {
      attrs = {};
    }

    if (!transform) {
      transform = Identity;
    }

    let text = this[key];
    let wrapFn;

    if (typeof wrap === 'string') {
      wrapFn = function tagWrapper (content) {
        return makeTagString(wrap, attrs, content);
      };
    } else {
      wrapFn = wrap;
    }

    return {__html: transform(text.replace(markerPattern, (_, match) => wrapFn(match)))};
  }

  replaceParams (key, values, attrs) {
    let text = this[key];

    for (let marker in values) {
      let pattern = new RegExp(namedMarkerPattern.replace(/MARKER/g, marker));
      text = text.replace(pattern, (_, match) => {
        attrs.href = values[marker];
        return makeTagString('a', attrs, match);
      });

      let strPattern = new RegExp(stringReplacePattern.replace(/MARKER/g, marker));
      text = text.replace(strPattern, (_, _match) => values[marker]);
    }
    return {__html: text};
  }
}

export const locale = new Locale();

export function loadLocale (name, callback) {
  locale.name = name;
  callback(locale);
  // let loadLang = require(`bundle?lazy&name=lang-[name]!loc/${name}.json`);
  // loadLang(strings => {
  //   Object.assign(locale, strings);
  //   locale.name = name;
  //   callback(locale);
  // })
}



// WEBPACK FOOTER //
// ./lib/rlink-i18n/i18n.js